module.exports = __webpack_public_path__ + "img/AZN.50163ed9.svg";